export const dataset = [
	{ id: 2, vote: "Cg-_0RuJYu4" },
	{ id: 3, vote: "Cg-_87JpIKz" },
	{ id: 4, vote: "Cg_AGOtJ_JA" },
	{ id: 5, vote: "Cg_AKGcJyOi" },
	{ id: 6, vote: "Cg_APB5Jhw-" },
	{ id: 7, vote: "Cg_Acy0JaV5" },
	{ id: 9, vote: "Cg_AhrXJ1W4" },
	{ id: 12, vote: "Cg_AmJAJdax" },
	{ id: 14, vote: "Cg_AykCp2AQ" },
	{ id: 15, vote: "Cg_A16bJmNr" },
	{ id: 17, vote: "Cg_BCgKJSB_" },
	{ id: 20, vote: "Cg_BIYgJVXG" },
	{ id: 22, vote: "Cg_DiRjPDII" },
	{ id: 25, vote: "Cg_DsyxvBdY" },
	{ id: 26, vote: "Cg_D4nbvGtY" },
];
